import { ICartEntry, MenuObject } from '@rbi-ctg/menu';
import { useMenuContext } from 'state/menu';
import { useOffersContext } from 'state/offers';
import { CartEntryType } from 'utils/cart';
import { maybeMapCartEntryToMenuObjectIdentifier } from 'utils/menu';

const mapUiPatternToItem = (menuItem: MenuObject | null, cartEntry: ICartEntry) => {
  const optionIds = ((menuItem?.options as Array<{ _id: string }>) || []).reduce((acc, option) => {
    acc[option._id] = option;
    return acc;
  }, {});
  const children = cartEntry.children.map(child => {
    const cloneChild = { ...child };
    const childIsComboOrComboSlot = [CartEntryType.combo, CartEntryType.comboSlot].includes(
      cloneChild.type as CartEntryType
    );
    if (childIsComboOrComboSlot) {
      cloneChild.uiPattern = cloneChild.uiPattern || optionIds[child.sanityId]?.uiPattern;
      // recurse through combo children to check for additional combos as children
      cloneChild.children = cloneChild.children.map(comboChild =>
        mapUiPatternToItem(menuItem, comboChild)
      );
    }
    return cloneChild;
  });
  return { ...cartEntry, children };
};

export const useMapUIPatternToItem = (cartEntry: ICartEntry) => {
  const menuCtx = useMenuContext();

  const { isSelectedOfferCartEntry } = useOffersContext();

  const menuIdentifier = !isSelectedOfferCartEntry(cartEntry)
    ? maybeMapCartEntryToMenuObjectIdentifier(cartEntry)
    : null;
  // If a mapping cant be done, return cartEntry unmapped
  if (!menuIdentifier) {
    return { item: cartEntry, loading: false };
  }

  const { data, loading } = menuCtx?.getMenuObject?.(menuIdentifier) || {};
  const item = mapUiPatternToItem(data, cartEntry);

  return { item, loading };
};
